<template>
  <v-container id="group-list">
    <city-header :payload="city"> </city-header>

    <v-row>
      <v-col>Membros</v-col>
      <v-col class="text-right">
        <app-modal-insert-member
          :edit="false"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          :municipioId="municipioId"
          :grupoId="grupoId"
          @onSave="loadMembers()"
        >
          <template v-slot:title :edit="false"> Cadastrar Membro </template>
        </app-modal-insert-member>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item="props">
            <tr :class="{ info: props.item.membroGrupos[0].lider === true }">
              <td>{{ props.item.nome | esconderValores("nome") }}</td>
              <td>{{ props.item.membroGrupos[0].grupo.nome }}</td>
              <td>{{ props.item.cpf | esconderValores("cpf") }}</td>
              <td>{{ props.item.email | esconderValores("email") }}</td>
              <td>{{ props.item.telefone | esconderValores("telefone") }}</td>
              <td>{{ props.item.orgao }}</td>
              <td>{{ props.item.cargo }}</td>
              <td>
                <v-row style="flex-wrap: nowrap">
                  <v-col align="center">
                    <app-modal-insert-member
                      :object="props.item"
                      :edit="true"
                      :color="'warning'"
                      :icon="'mdi-pencil'"
                      :municipioId="payload.municipioId"
                      @onSave="loadMembers"
                      class="btn-table"
                    >
                      <template v-slot:title> Edição de Membro </template>
                    </app-modal-insert-member>
                  </v-col>
                  <v-col align="center">
                    <app-modal-confirm-delete-member
                      :member="props.item"
                      @onCloseModal="loadMembers()"
                    >
                      <template v-slot:title>
                        Excluir Membro de Grupo
                      </template>
                    </app-modal-confirm-delete-member>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span> Nenhum membro retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CityHeader from "../Header";
import AppModalInsertMember from "./ModalInsertMember";
import { memberAPI } from "../MemberAPI";
import { cityAPI } from "@/modules/city";
import { mapActions } from "vuex";
import AppModalConfirmDeleteMember from "./ModalConfirmDeleteMember";

export default {
  components: {
    CityHeader,
    AppModalInsertMember,
    AppModalConfirmDeleteMember,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Grupo", value: "grupo.nome" },
        { text: "CPF", value: "cpf" },
        { text: "E-mail", value: "email" },
        { text: "Telefone", value: "telefone" },
        { text: "Órgão / Secretaria", value: "orgao" },
        { text: "Cargo / Função", value: "cargo" },
        { text: "Ações", value: "acoes", sortable: false },
      ],
      payload: [],
      city: {},
      municipioId: this.$route.params.id,
      grupoId: this.$route.params.grupo,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadCity() {
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.city = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    loadMembers() {
      this.setLoading(true);
      this.payload = [];
      memberAPI
        .getMembers(this.$route.params.grupo)
        .then((resp) => {
          this.payload = resp.data;
          this.payload.municipioId = this.$route.params.id;
          this.loadCity();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
  },
  mounted() {
    this.loadMembers();
  },
};
</script>

<style scoped lang="scss">
@import "./../style.scss";
</style>
